
import React, { Component } from 'react';
import noDataImg from "images/no_data.png";
require("./index.scss");


class NoDataList extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };

    }

    render() {
        // let { total, pageSize, currentPage } = this.props;
        return (

            <div className="no_data_box"><img src={noDataImg} /></div>
        )
    }
}

export default NoDataList;